export const MobileSideNavLinks = [
    {
        title: "Home",
        url: "intro",
    },
    {
        title: "Coral Reef Recreation and Tourism",
        url: "coral-rec-tourism",
    },
    {
        title: "Nature-Dependent Beach Recreation and Tourism",
        url: "beach-rec-tourism",
    },
    {
        title: "Recreational Fishing",
        url: "rec-fishing",
    },
    {
        title: "Coral Reef Fisheries",
        url: "coral-reef-fisheries",
    },
    {
        title: "Wildlife Tourism",
        url: "wildlife-tourism",
    },
];
